import { PayloadAction } from '@reduxjs/toolkit';
import { CurrencyEnum } from '$store/models';

export enum BalancePayAction {
  TIPS = 'TIPS',
  MESSAGE = 'MESSAGE',
  SUBSCRIPTION_ADULT = 'SUBSCRIPTION_ADULT',
  TRIAL_SUBSCRIPTION_ADULT = 'TRIAL_SUBSCRIPTION_ADULT',
  TRIAL_LINK_ACTIVATE = 'TRIAL_LINK_ACTIVATE',
  QR_BONUS = 'QR_BONUS',
  ATTACH_CARD = 'ATTACH_CARD',
  SUBSCRIPTION_MEDIA = 'SUBSCRIPTION_MEDIA',
  SUBSCRIPTION_PERSONAL = 'SUBSCRIPTION_PERSONAL',
  BATTLE_DONATE = 'BATTLE_DONATE',
  ROULETTE = 'ROULETTE',
  VALENTINE = 'VALENTINE',
  BUNDLE = 'BUNDLE',
  GIFT = 'GIFT',
  APP_PURCHASE = 'APP_PURCHASE',
}

export interface BalancePayState {
  isActive: boolean;
  action: BalancePayAction | null;
  amount: number;
  objectId: number | null;
  currency: CurrencyEnum;
  extraId: number;
  isAnon?: boolean;
  period: number;
}

export type SetActiveAction = PayloadAction<boolean>;
export type OpenAction = PayloadAction<{
  action: BalancePayAction;
  amount: number;
  objectId: number | null;
  currency?: CurrencyEnum;
  extraId?: number;
  isAnon?: boolean;
  period?: number;
}>;
